import { createStore } from 'vuex'
import createPersistedState from 'vuex-persistedstate'

export default createStore({
  state: {
    token: '',
    permission: '',
    fullName: '',
    team: '',
    idleTimeoutSeconds: 43200,
    refreshIntervalSeconds: 3600,
    sessionExpired: false,
  },
  getters: {
    isLoggedIn (state): boolean {
      return !!state.token
    }
  },
  mutations: {
    setToken (state, token) {
      state.token = token
    },
    clearToken (state) {
      state.token = ''
    },
    setPermission (state, permisson) {
      state.permission = permisson
    },
    clearPermission (state) {
      state.permission = ''
    },
    setFullName (state, fullName) {
      state.fullName = fullName
    },
    clearFullName (state) {
      state.fullName = ''
    },
    setTeam (state, team) {
      state.team = team
    },
    clearTeam (state) {
      state.team = ''
    },
    setSessionConfig (state, config) {
      state.idleTimeoutSeconds = config.idleTimeoutSeconds
      state.refreshIntervalSeconds = config.refreshIntervalSeconds
    },
    expireSession (state) {
      state.sessionExpired = true
    },
    clearSessionExpired (state) {
      state.sessionExpired = false
    },
  },
  actions: {
    setToken ({ commit }, token) {
      commit('setToken', token)
    },
    clearToken ({ commit }) {
      commit('clearToken')
      window.sessionStorage.removeItem('qlts-last-activity-at')
    },
    setPermission ({ commit }, permission) {
      commit('setPermission', permission)
    },
    clearPermission ({ commit }) {
      commit('clearPermission')
    },
    setFullName ({ commit }, fullName) {
      commit('setFullName', fullName)
    },
    clearFullName ({ commit }) {
      commit('clearFullName')
    },
    setTeam ({ commit }, team) {
      commit('setTeam', team)
    },
    clearTeam ({ commit }) {
      commit('clearTeam')
    },
    setSessionConfig ({ commit }, config) {
      commit('setSessionConfig', config)
    },
    expireSession ({ commit }) {
      commit('expireSession')
    },
    clearSessionExpired ({ commit }) {
      commit('clearSessionExpired')
    },
  },
  modules: {
  },
  // Giữ phiên trong tab hiện tại để Ctrl/Cmd+R không làm mất đăng nhập.
  // sessionStorage không tồn tại lâu như localStorage và sẽ được dọn khi kết thúc phiên tab.
  plugins: [createPersistedState({
    key: 'qlts-session',
    storage: window.sessionStorage,
    reducer: (state: any) => ({
      token: state.token,
      permission: state.permission,
      fullName: state.fullName,
      team: state.team,
      idleTimeoutSeconds: state.idleTimeoutSeconds,
      refreshIntervalSeconds: state.refreshIntervalSeconds,
      sessionExpired: state.sessionExpired,
    })
  })]
})
